'use strict';

/* !
 * jQuery index v1.0.0
 * Copyright 2018, Connecty Inc.
 */
(function ($) {
	var a = 'is-active',
	    v = 'is-visible',
	    f = 'is-fixed';
	var $url = location.pathname;

	if ($) {
		var d = new $.Deferred();
	}
	// 指定した関数を 0.5 秒後に実行する
	function async(func) {
		setTimeout(func, 500);
	}

	// ブランドサイト
	if ($('.brand-prodPanelWrap').length) {
		// favIcon();
		prodPanelModal();
		soldOut();
		// favToggle();
	}

	// ソールドアウト表示
	function soldOut() {
		var $prodItem = $('.mod-prodPanel');
		$prodItem.each(function (index, element) {
			var code7 = $(element).find('.rt_cf_p_code_7').attr('data-p_code_7');

			$.getJSON('/ajax/products/glasses/' + code7 + '.json').then(function (data) {
				if (data.rt_bn_product_list.length === 0) {
					$(element).find('.mod-prodPanel-iconWrap').append('<span class="mod-prodPanel-soldout">SOLD OUT</span>');
					$(element).find('.rt_p_href').attr('href', '');
					$(element).addClass('mod-prodPanel-noLink');
				}
			});
		});
	}

	function prodDetailSizeSelect() {
		// 試着予約へパラメータを引き継ぐ
		var reservationBtn2 = $('.colorSelect-panel-submit .mod-button-a');

		$('.colorSelect-panel').find('.mod-check-input').change(function () {
			var bikouArr2 = [],
			    nameArr2 = [],
			    colorArr2 = [],
			    sizeArr2 = [],
			    priceArr2 = [];
			var checkedItem = $('.colorSelect-panel .mod-tbl02').find('input:checkbox:checked');
			var checkedItemLen = checkedItem.length;
			// サイズを1つ選択したら「選択する」ボタンを押下可能にする&その他は選択不可にする
			if (checkedItemLen === 0) {
				reservationBtn2.removeClass('is-hover01');
			} else if (checkedItemLen > 6) {
				$(this).prop('checked', false);
				alert('試着予約は合計で最大６本までお受けいたします。');
			} else {
				reservationBtn2.addClass('is-hover01');
			}

			$('.colorSelect-panel').find('.mod-check-input').each(function () {
				if ($(this).prop('checked') === true) {
					var checkedItemBikou2 = $(this).attr('data-p-bikou'),
					    checkedItemName2 = $(this).attr('data-p-name'),
					    checkedItemColor2 = $(this).attr('data-p-color'),
					    checkedItemSize2 = $(this).attr('data-p-size'),
					    checkedItemPrice2 = $(this).attr('data-p-price');

					bikouArr2.push(checkedItemBikou2);
					nameArr2.push(checkedItemName2);
					colorArr2.push(checkedItemColor2);
					sizeArr2.push(checkedItemSize2);
					priceArr2.push(checkedItemPrice2);
				}
			});

			var param2 = 'bikou=' + bikouArr2.join(',') + '&item_name=' + nameArr2.join(',') + '&item_color=' + colorArr2.join(',') + '&item_size=' + sizeArr2.join(',') + '&item_price=' + priceArr2.join(',') + '&site=corporate';

			reservationBtn2.attr('href', '/inquiry/trying_on/?' + param2);
		});
	}

	// ＜共通＞お気に入り商品にアイコン点灯
	function favIcon() {
		$('.mod-prodPanel').each(function () {
			var $this = $(this);
			var thisProdCode = $(this).find('.rt_cf_p_code_8').attr('data-p_code_8');
			var flgFavo = checkFavo(thisProdCode);
			if (flgFavo) {
				$this.find('.mod-prodPanel-favorite').addClass(a);
			} else {
				$this.find('.mod-prodPanel-favorite').removeClass(a);
			}
		});
	}

	// お気に入りに追加,削除
	function favToggle() {
		$('.prod-modal-fav-a, .prod-detail-favBtn-a, .mod-prodPanel-favorite').on('click', function () {
			var $this = $(this);
			var prodCode;

			if ($this.hasClass('mod-prodPanel-favorite')) {
				prodCode = $this.parents('.mod-prodPanel').find('.rt_cf_p_code_8').attr('data-p_code_8');

				// 商品詳細
				if ($('.prod-detail').length) {
					var $sku = $('.rt_cf_p_code_8_sku').attr('data-p_code_8');
					if ($this.prev('.rt_cf_p_code_8').attr('data-p_code_8') === $sku) {
						$('.prod-detail-favBtn-a').removeClass(a);
					}
				}
			} else if ($this.hasClass('prod-detail-favBtn-a')) {
				prodCode = $this.attr('data-p_code_8');
			} else if ($this.hasClass('prod-modal-fav-a')) {
				prodCode = $this.parents('.prod-modal').find('.rt_cf_p_code_8').attr('data-p_code_8');
				$this.removeClass('is-hover01');
				$this.parents('.mod-prodPanel').find('.mod-prodPanel-favorite').addClass(a);
			}

			if (!$this.hasClass(a)) {
				var favoDatetime = new Date();
				favoDatetime = favoDatetime.toLocaleString();
				localStorage.setItem('favItem-' + prodCode, favoDatetime);
				$this.addClass(a);
			} else {
				localStorage.removeItem('favItem-' + prodCode);
				$this.removeClass(a);
			}

			// お気に入り商品数をフロートナビに反映
			var $floatNav = $('.floatNav');
			var favoStorage = [];
			var favArr = [];
			for (var i in localStorage) {
				if (i.indexOf('favItem-') !== -1) {
					favoStorage.push(i);
				}
			}

			for (var _i = 0; _i < favoStorage.length; _i++) {
				var hash = {
					name: favoStorage[_i],
					datetime: localStorage[favoStorage[_i]]
				};
				favArr.push(hash);
			}
			favArr.sort(function (x, y) {
				var xDate = x['datetime'];
				var yDate = y['datetime'];
				if (xDate > yDate) return 1;
				if (xDate < yDate) return -1;
				return 0;
			});

			// お気に入り登録数は12まで
			if (favoStorage.length > 12) {
				localStorage.removeItem(favArr[0].name);
				favoStorage.pop();
			}

			// フロートナビにお気に入り商品数を表示
			$floatNav.find('.icon-favorite').addClass(a);
			setTimeout(function () {
				$floatNav.find('.icon-favorite').removeClass(a);
			}, 170);
			$floatNav.find('.icon-favorite').next('span').text(favoStorage.length);

			// 商品詳細のお気に入りリストブロックにお気に入り商品数を表示
			$('.prod-detail-favBlock .favNum').text(favoStorage.length);

			if ($('.prod-detail').length) {
				// 指定した関数を 0.5 秒後に実行する
				var _async = function _async(func) {
					setTimeout(func, 500);
				};

				if ($) {
					var d = new $.Deferred();
				}

				$('.mod-favList').children('.mod-favList-wrap').remove();

				_async(function () {
					getFavoList();
					favIcon();
					d.resolve();
				});

				d.promise().then(function () {
					_async(function () {
						getFavoItemSize();
						sizeSelectToggle();
					});
				}).then(function () {
					_async(function () {
						prodPanelModal();
						$('.mod-prodPanel').matchHeight();
					});
				}).then(function () {
					_async(function () {
						sizeSelectfire();
					});
				});
			}
		});
	}

	// カテゴリーページ ブランドごとの商品を描画
	function brandItemCreate() {
		var $cat = $url.split('/')[$url.split('/').length - 1].replace(/\.html/, '');
		var brandBlock = $('.prod-cat-bland'),
		    $select = $('.prod-cat-select select');

		// プルダウンメニュー
		$select.on('change', function () {
			var $href = $(this).val() + '.html';
			location.href = $href;
		});
		$select.val($cat);

		brandBlock.each(function () {
			var brandKey = $(this).find('.rt_cf_pb_key').attr('data-cf_pb_key'),
			    output = $(this).find('.prod-brand-output'),
			    output01 = output.children('.prod-brand-output-01'),
			    output02 = output.children('.prod-brand-output-02').children('.pure-g');

			$.ajax({
				type: 'GET',
				url: '/ajax/product/brand/' + brandKey + '.json',
				dataType: 'json',
				timeout: 5000
			}).done(function (data) {
				var prodList = data.rt_bn_product_list;
				var prodListLen = prodList.length;

				var newHTML;

				var firstItemDetail = {
					name: prodList[0]['cf_p_model'],
					img: prodList[0]['rt_p_img'].src,
					price: prodList[0]['rt_cf_p_tax_included_price'].content,
					code7: prodList[0]['cf_p_code_7'],
					code8: prodList[0]['cf_p_code_8'],
					new: prodList[0]['rt_p_new']
				};
				if (firstItemDetail.new !== null) {
					newHTML = '<span class="mod-prodPanel-new">NEW</span>';
				} else {
					newHTML = '';
				}
				var firstModalHTML = '<div class="prod-modal"><div class="prod-modal-inner"><i class="icon icon-close"></i>' + '<span class="di_none rt_cf_p_code_8" data-p_code_8="' + firstItemDetail.code8 + '"></span>' + newHTML + '<a href="/products/glasses/detail/' + firstItemDetail.code7 + '.html" class="prod-modal-a rt_p_href">' + '<img src="' + firstItemDetail.img + '" alt="' + firstItemDetail.name + '" class="width-u-100 rt_p_img"></a>' + '<a href="/products/glasses/detail/' + firstItemDetail.code7 + '.html" class="prod-modal-a rt_p_href">' + '<p class="prod-modal-name rt_cf_p_model">' + firstItemDetail.name + '</p>' + '<p class="prod-modal-price rt_cf_p_tax_included_price">' + firstItemDetail.price + '</p></a>' + '<div class="prod-modal-btnWrap"><ul class="pure-g space-u-20">' + '<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child">' + '<div class="mod-button prod-modal-fav"><span class="mod-button-a prod-modal-fav-a is-hover01">' + '<span class="mod-button-txt"></span>' + '<i class="icon icon-favorite mod-iconArrowRight"></i></span></div></li>' + '<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child"><div class="mod-button">' + '<a href="/products/glasses/detail/' + firstItemDetail.code7 + '.html" class="mod-button-a is-hover01 rt_p_href">' + '<span class="mod-button-txt">商品詳細</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' + '</a></div></li></ul></div></div></div>';

				var firstProdHTML = '<div class="mod-prodPanel mod-prodPanel_large">' + '<div class="mod-prodPanel-iconBlock">' + '<span class="di_none rt_cf_p_code_8" data-p_code_8="' + firstItemDetail.code8 + '"></span>' + newHTML + '<span class="mod-prodPanel-favorite"><i class="icon icon-favorite"></i></span>' + '<a href="" class="mod-prodPanel-modal js-modal-btn"><i class="icon icon-search"></i></a></div>' + '<a href="/products/glasses/detail/' + firstItemDetail.code7 + '.html" class="mod-a rt_p_href">' + '<img src="' + firstItemDetail.img + '" alt="" class="width-u-100 rt_p_img"></a>' + '<div class="mod-prodPanel-text"><div class="mod-prodPanel-text-inner">' + '<a href="/products/glasses/detail/' + firstItemDetail.code7 + '.html" class="mod-a rt_p_href">' + '<p class="mod-prodPanel-text_name">' + firstItemDetail.name + '</p>' + '<p class="mod-prodPanel-text_price">' + firstItemDetail.price + '</p></a></div></div>' + firstModalHTML + '</div>';
				$(firstProdHTML).appendTo(output01);

				for (var j = 1; j < prodListLen; j++) {
					var itemDetail = {
						name: prodList[j]['cf_p_model'],
						img: prodList[j]['rt_p_img'].src,
						price: prodList[j]['rt_cf_p_tax_included_price'].content,
						code7: prodList[j]['cf_p_code_7'],
						code8: prodList[j]['cf_p_code_8'],
						new: prodList[j]['rt_p_new']
					};

					if (itemDetail.new !== null) {
						newHTML = '<span class="mod-prodPanel-new">NEW</span>';
					} else {
						newHTML = '';
					}

					var modalHTML = '<div class="prod-modal"><div class="prod-modal-inner"><i class="icon icon-close"></i>' + '<span class="di_none rt_cf_p_code_8" data-p_code_8="' + itemDetail.code8 + '"></span>' + newHTML + '<a href="/products/glasses/detail/' + itemDetail.code7 + '.html" class="prod-modal-a rt_p_href">' + '<img src="' + itemDetail.img + '" alt="' + itemDetail.name + '" class="width-u-100 rt_p_img"></a>' + '<a href="/products/glasses/detail/' + itemDetail.code7 + '.html" class="prod-modal-a rt_p_href">' + '<p class="prod-modal-name rt_cf_p_model">' + itemDetail.name + '</p>' + '<p class="prod-modal-price rt_cf_p_tax_included_price">' + itemDetail.price + '</p></a>' + '<div class="prod-modal-btnWrap"><ul class="pure-g space-u-20">' + '<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child">' + '<div class="mod-button prod-modal-fav"><span class="mod-button-a prod-modal-fav-a is-hover01">' + '<span class="mod-button-txt"></span>' + '<i class="icon icon-favorite mod-iconArrowRight"></i></span></div></li>' + '<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child"><div class="mod-button">' + '<a href="/products/glasses/detail/' + itemDetail.code7 + '.html" class="mod-button-a is-hover01 rt_p_href">' + '<span class="mod-button-txt">商品詳細</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' + '</a></div></li></ul></div></div></div>';

					var prodHTML = '<li class="pure-u-1-2 space-u-20-child"><div class="mod-prodPanel">' + '<div class="mod-prodPanel-iconBlock">' + '<span class="di_none rt_cf_p_code_8" data-p_code_8="' + itemDetail.code8 + '"></span>' + newHTML + '<span class="mod-prodPanel-favorite"><i class="icon icon-favorite"></i></span>' + '<a href="" class="mod-prodPanel-modal js-modal-btn"><i class="icon icon-search"></i></a></div>' + '<a href="/products/glasses/detail/' + itemDetail.code7 + '.html" class="mod-a rt_p_href">' + '<img src="' + itemDetail.img + '" alt="" class="width-u-100 rt_p_img"></a><div class="mod-prodPanel-text">' + '<a href="/products/glasses/detail/' + itemDetail.code7 + '.html" class="mod-a rt_p_href">' + '<p class="mod-prodPanel-text_name">' + itemDetail.name + '</p>' + '<p class="mod-prodPanel-text_price">' + itemDetail.price + '</p></a>' + '</div>' + modalHTML + '</div></li>';

					$(prodHTML).appendTo(output02);
				}
			});
		});
	}

	// サイズ選択パネル表示切替
	function sizeSelectToggle() {
		var sizeSelectBtn = $('.mod-favList-item-btn');
		var sizeSelect = $('.sizeSelect');

		sizeSelectBtn.on('click', function () {
			console.log('click');
			if ($(this).hasClass(a)) {
				sizeSelectBtn.removeClass(a);
				sizeSelect.removeClass(a);
				$(this).removeClass(a);
				$(this).next(sizeSelect).removeClass(a);
			} else {
				sizeSelectBtn.removeClass(a);
				sizeSelect.removeClass(a);
				$(this).addClass(a);
				$(this).next(sizeSelect).addClass(a);
			}
		});
	}

	function sizeSelectfire() {
		var clearBtn = $('.icon-close'),
		    reservationBtn = $('.reservationBtn'),
		    favItem = $('.mod-favList-item'),
		    bikouArr = [],
		    nameArr = [],
		    colorArr = [],
		    sizeArr = [],
		    priceArr = [];

		// サイズを1つ以上選択したら「選択する」ボタンを押下可能にする
		$('.mod-favList').on('change', '.sizeSelect .mod-check-input', function () {
			var checkedItem = $(this).parents('.sizeSelect').find('input:checkbox:checked');
			var checkedItemLen = checkedItem.length;
			var checkedItemAll = $(this).parents('.mod-favList').find('input:checkbox:checked').length;

			if (checkedItemLen !== 0) {
				$(this).parents('.sizeSelect').find('.mod-button-a').addClass('is-hover01');

				$('.sizeSelect-btn').find('.mod-button-a').on('click', function () {
					$(this).parents('.sizeSelect').prev('.mod-favList-item-btn').removeClass(a);
					$(this).parents('.sizeSelect').removeClass(a);
					$(this).parents('.mod-favList-item').addClass('selected');

					// 試着（来店）予約ボタンを押下可能にする
					reservationBtn.addClass('is-hover01');
				});
			} else {
				$(this).parents('.sizeSelect').find('.mod-button-a').removeClass('is-hover01');
			}

			// チェック数が6を超えたらアラートを出す
			if (checkedItemAll > 6) {
				$(this).prop('checked', false);
				alert('試着予約は合計で最大６本までお受けいたします。');
				if ($(this).parents('.sizeSelect').find('input:checkbox:checked').length === 0) {
					$(this).parents('.sizeSelect').find('.sizeSelect-btn .mod-button-a').removeClass('is-hover01');
				}
			}
		});

		// paramArrに追加
		$('.sizeSelect-btn .mod-button-a').on('click', function () {
			$(this).parents('.sizeSelect').find('.mod-check-input').each(function () {
				if ($(this).prop('checked') === true) {
					var checkedItemBikou = $(this).attr('data-p-bikou');
					var checkedItemName = $(this).attr('data-p-name');
					var checkedItemColor = $(this).attr('data-p-color');
					var checkedItemSize = $(this).attr('data-p-size');
					var checkedItemPrice = $(this).attr('data-p-price');
					bikouArr.push(checkedItemBikou);
					nameArr.push(checkedItemName);
					colorArr.push(checkedItemColor);
					sizeArr.push(checkedItemSize);
					priceArr.push(checkedItemPrice);
				}
			});

			// パラメータを引き継ぐ
			var param = 'bikou=' + bikouArr.join(',') + '&item_name=' + nameArr.join(',') + '&item_color=' + colorArr.join(',') + '&item_size=' + sizeArr.join(',') + '&item_price=' + priceArr.join(',') + '&site=corporate';
			reservationBtn.attr('href', '/inquiry/trying_on/?' + param);
		});

		// ×アイコンをクリックしたらチェックボックスの選択を外す
		clearBtn.on('click', function () {
			$(this).parent(favItem).removeClass('selected');
			$(this).parent(favItem).find('.sizeSelect').find('.mod-check-input').prop('checked', false);
			$(this).parent(favItem).find('.sizeSelect-btn .mod-button-a').removeClass('is-hover01');

			// paramArrから削除
			$(this).parent(favItem).find('.sizeSelect').find('.mod-check-input').each(function () {
				var removeItemBikou = $(this).attr('data-p-bikou'),
				    removeItemName = $(this).attr('data-p-name'),
				    removeItemColor = $(this).attr('data-p-color'),
				    removeItemSize = $(this).attr('data-p-size'),
				    removeItemPrice = $(this).attr('data-p-price');

				bikouArr.forEach(function (item, index) {
					if (item === removeItemBikou) {
						bikouArr.splice(index, 1);
					}
				});
				nameArr.forEach(function (item, index) {
					if (item === removeItemName) {
						nameArr.splice(index, 1);
					}
				});
				colorArr.forEach(function (item, index) {
					if (item === removeItemColor) {
						colorArr.splice(index, 1);
					}
				});
				sizeArr.forEach(function (item, index) {
					if (item === removeItemSize) {
						sizeArr.splice(index, 1);
					}
				});
				priceArr.forEach(function (item, index) {
					if (item === removeItemPrice) {
						priceArr.splice(index, 1);
					}
				});
			});

			// パラメータを引き継ぐ
			var param = 'bikou=' + bikouArr.join(',') + '&item_name=' + nameArr.join(',') + '&item_color=' + colorArr.join(',') + '&item_size=' + sizeArr.join(',') + '&item_price=' + priceArr.join(',') + '&site=corporate';
			reservationBtn.attr('href', '/inquiry/trying_on/?' + param);

			// サイズが選択された商品がない場合、試着（来店）予約ボタンを押下不可にする
			if ($('.mod-favList-item.selected').length === 0) {
				reservationBtn.removeClass('is-hover01');
			}
		});
	}

	// お気に入り商品かチェック
	function checkFavo(_thisProdCode) {
		for (var item in localStorage) {
			if (item.indexOf('favItem-') !== -1) {
				if (item.replace(/favItem-/, '') === _thisProdCode) {
					return true;
				}
			}
		}
		return false;
	}

	// localStorageからお気に入りリスト取得&描画
	function getFavoList() {
		var favoStorage = [];
		var favArr = [];
		var itemArr = {};

		var getJSONgetFavoList = function getJSONgetFavoList(_code) {
			return $.getJSON('/ajax/product/product/' + _code + '.json');
		};

		for (var i in localStorage) {
			if (i.indexOf('favItem-') !== -1) {
				favoStorage.push(i);
			}
		}
		for (var _i2 = 0; _i2 < favoStorage.length; _i2++) {
			var hash = {
				name: favoStorage[_i2],
				datetime: localStorage[favoStorage[_i2]]
			};
			favArr.push(hash);
		}
		favArr.sort(function (x, y) {
			var xDate = x['datetime'];
			var yDate = y['datetime'];
			if (xDate > yDate) return -1;
			if (xDate < yDate) return 1;
			return 0;
		});

		var checkSizeArr = function checkSizeArr(_itemArr) {
			if (Object.keys(_itemArr).length === favArr.length) {
				for (var _i3 = 0; _i3 < favArr.length; _i3++) {
					$('.mod-favList').append(_itemArr['' + _i3]);
				}
			}
		};
		if (favoStorage.length > 0) {
			var _loop = function _loop(_i4) {
				getJSONgetFavoList('' + favArr[_i4].name.replace(/favItem-/, '')).then(function (data) {
					if (data.rt_bn_product_list.length) {
						var thisData = {
							code7: data.rt_bn_product_list[0].cf_p_code_7,
							code8: data.rt_bn_product_list[0].cf_p_code_8,
							img: data.rt_bn_product_list[0].rt_p_img.src,
							name: data.rt_bn_product_list[0].cf_p_model,
							price: data.rt_bn_product_list[0].rt_cf_p_tax_included_price.content,
							new: data.rt_bn_product_list[0].rt_p_new
						};

						var newHTML;
						if (thisData.new !== null) {
							newHTML = '<span class="mod-prodPanel-new">NEW</span>';
						} else {
							newHTML = '';
						}

						var modalHTML = '<div class="prod-modal"><div class="prod-modal-inner"><i class="icon icon-close"></i>' + '<span class="di_none rt_cf_p_code_8" data-p_code_8="' + thisData.code8 + '"></span>' + newHTML + '<a href="/products/glasses/detail/' + thisData.code7 + '.html#' + thisData.code8 + '" class="prod-modal-a rt_p_href">' + '<img src="' + thisData.img + '" alt="' + thisData.name + '" class="width-u-100 rt_p_img"></a>' + '<a href="/products/glasses/detail/' + thisData.code7 + '.html#' + thisData.code8 + '" class="prod-modal-a rt_p_href">' + '<p class="prod-modal-name rt_cf_p_model">' + thisData.name + '</p>' + '<p class="prod-modal-price rt_cf_p_tax_included_price">' + thisData.price + '</p></a>' + '<div class="prod-modal-btnWrap"><ul class="pure-g space-u-20">' + '<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child">' + '<div class="mod-button prod-modal-fav"><span class="mod-button-a prod-modal-fav-a is-hover01">' + '<span class="mod-button-txt"></span>' + '<i class="icon icon-favorite mod-iconArrowRight"></i></span></div></li>' + '<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child"><div class="mod-button">' + '<a href="/products/glasses/detail/' + thisData.code7 + '.html#' + thisData.code8 + '" class="mod-button-a is-hover01 rt_p_href">' + '<span class="mod-button-txt">商品詳細</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' + '</a></div></li></ul></div></div></div>';

						var favHTML = '<li class="pure-u-1-4 pure-u-md-1-2 space-u-20-child mod-favList-wrap">' + '<div class="mod-favList-item"><i class="icon icon-close"></i>' + '<div class="mod-prodPanel">' + '<div class="mod-prodPanel-iconBlock">' + '<span class="di_none rt_cf_p_code_8" data-p_code_8="' + thisData.code8 + '"></span>' + newHTML + '<span class="mod-prodPanel-favorite is-active"><i class="icon icon-favorite"></i></span>' + '<a href="" class="mod-prodPanel-modal js-modal-btn"><i class="icon icon-search"></i></a>' + '</div>' + '<a href="/products/glasses/detail/' + thisData.code7 + '.html#' + thisData.code8 + '" class="mod-a rt_p_href">' + '<img src=" ' + thisData.img + '" alt="' + thisData.name + '" class="width-u-100 rt_p_img"></a>' + '<div class="mod-prodPanel-text">' + '<a href="/products/glasses/detail/' + thisData.code7 + '.html#' + thisData.code8 + '" class="mod-a rt_p_href">' + '<p class="mod-prodPanel-text_name">' + thisData.name + '</p>' + '<p class="mod-prodPanel-text_price">' + thisData.price + '</p></a></div>' + modalHTML + '</div>' + '<div class="mod-favList-item-btn">' + '<span class="mod-favList-item-txt">サイズを選ぶ<i class="icon icon-arrow_bottom mod-iconArrowRight"></i>' + '</span><span class="mod-favList-item-txt_selected">選択済</span></div>' + '<div class="sizeSelect"><div class="sizeSelect-inner">' + '<img src="/images/products/img_triangle.png" alt="" class="triangle"><ul></ul>' + '<div class="sizeSelect-btn"><div class="mod-button"><span class="mod-button-a">' + '<span class="mod-button-txt">選択する</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' + '</span></div></div></div>' + '</div></div></li>';
						itemArr['' + _i4] = favHTML;
						checkSizeArr(itemArr);
					}
				});
			};

			for (var _i4 = 0; _i4 < favArr.length; _i4++) {
				_loop(_i4);
			}
			$('.prod-fav-no_favItem').removeClass(v);
		} else {
			$('.prod-fav-no_favItem').addClass(v);
		}
	}

	// お気に入りのサイズと在庫を取得
	function getFavoItemSize() {
		$('.mod-favList-item').each(function () {
			var thisCode = $(this).find('.rt_cf_p_code_8').attr('data-p_code_8');

			// サイズと在庫数取得用のjson
			var sizeJsonPath = '/ajax/product_list.json?p_code_8=' + thisCode;

			var $ul = $(this).find('.sizeSelect').find('ul');

			// サイズと在庫取得
			$.ajax({
				type: 'GET',
				url: sizeJsonPath,
				dataType: 'json',
				timeout: 5000
			}).done(function (data) {
				var sizeList = data.rt_bn_product_list;
				var sizeListLen = sizeList.length;

				for (var k = 0; k < sizeListLen; k++) {
					var thisSize = {
						name: sizeList[k]['cf_p_model'],
						color: sizeList[k]['cf_p_color_name_2'],
						size: sizeList[k]['cf_p_size'],
						spacing: sizeList[k]['cf_p_size_spacing'],
						temple: sizeList[k]['cf_p_size_temple'],
						vertical: sizeList[k]['cf_p_size_vertical'],
						stock: sizeList[k]['cf_ps_center_number'],
						code8: sizeList[k]['cf_p_code_8'],
						price: sizeList[k]['cf_p_tax_included_price'],
						key: sizeList[k]['_key']
					};

					var stockText;
					if (thisSize.stock < 10) {
						stockText = '<span class="stock">残りわずか</span>';
					} else {
						stockText = '';
					}
					var sizeAll;
					if (sizeListLen > 1) {
						sizeAll = '<li><label class="mod-check" for="">' + '<input class="mod-check-input" type="checkbox" name="" id="" value="" data-p-bikou="' + thisSize.code8 + 'x" data-p-name="' + encodeURI(thisSize.name) + '" data-p-color="' + encodeURI(thisSize.color) + '" data-p-size="free" data-p-price="' + thisSize.price + '"> ' + '<span class="mod-check-text fs_14"><span>指定なし</span></span></label></li>';
					} else {
						sizeAll = '';
					}

					var sizeText = thisSize.size + '□' + thisSize.spacing + '－' + thisSize.temple + '　レンズ縦幅' + thisSize.vertical + 'mm';

					var sizeHTML = '<li><label class="mod-check" for="">' + '<input class="mod-check-input" type="checkbox" name="" id="" value="" data-p-bikou="' + thisSize.key + '" data-p-name="' + encodeURI(thisSize.name) + '" data-p-color="' + encodeURI(thisSize.color) + '" data-p-size="' + encodeURI(sizeText) + '" data-p-price="' + thisSize.price + '">' + '<span class="mod-check-text fs_14">' + stockText + '<span>' + sizeText + '</span></span></label></li>';
					$(sizeHTML).appendTo($ul);
				}
				$(sizeAll).appendTo($ul);
			});
		});
	}

	function prodPanelModal() {

		var $modal = $('.js-modal');
		var $modalContent = $('.js-modal-content');
		var m = 'is-modal';
		var scrollTopNow = void 0;
		var $modalItem;

		$('.js-modal-btn, .colorSelect-btn .mod-button-a').on('click', function (e) {
			if ($(e.currentTarget).hasClass('js-modal-btn')) {
				// mod-prodPanelのモーダル
				$modalItem = $('.prod-modal');
				var thisProd = $(e.currentTarget).parents('.mod-prodPanel');
				thisProd.children('.prod-modal').addClass(m);
				if (thisProd.find('.mod-prodPanel-favorite.is-active').length !== 0) {
					thisProd.children('.prod-modal').find('.prod-modal-fav-a').removeClass('is-hover01').addClass(a);
				} else {
					thisProd.children('.prod-modal').find('.prod-modal-fav-a').addClass('is-hover01').removeClass(a);
				}
			} else {
				// 商品詳細のカラー（サイズ）選択リスト
				$modalItem = $('.colorSelect-panel').addClass(m);
			}

			prodDetailSizeSelect();

			$modal.addClass(a);
			scrollTopNow = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrollTopNow,
				left: 0
			});

			$('body').addClass(f);
			e.preventDefault();
		});

		$modalContent.on('click', function (e) {
			if (!$(e.target).closest('.mod-button, .mod-a, .colorSelect-panel').length) {
				$modal.removeClass(a);
				$modalItem.removeClass(m);
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
				e.preventDefault();
			}
		});

		$('.js-modal-overlay, .prod-modal .icon-close, .colorSelect-panel .icon-close').on('click', function (e) {
			$modal.removeClass(a);
			$modalItem.removeClass(m);
			$('.container').css({
				position: 'static'
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrollTopNow);
			e.preventDefault();
		});
	}
})(window.jQuery);